/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { Button, Dropdown } from 'react-bootstrap';

import Grid from '../../../../../../SharedModules/Table/TableGridWithFeatures';
import { CMS_DRUG_TABLEHEAD } from '../../../utility/tableHeads';
import CustomDateComponent from '../../CustomDateComponent';
import CommentVisibleIcon from '../../../../../../assets/images/commen-visible-icon.svg';
import CommentIcon from '../../../../../../assets/images/comment-dots.svg';
import CommentAndCorrespondenceComponent from '../../../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import CMSDrugURAUpdationDialog from './CMSDrugURA/CMSDrugURAUpdationDialog';
import SVGComponent from '../../../../../../SharedModules/SVGComponents/SVGComponents';

import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { setCurrentNDCDetailsSelected } from '../../../store/action';

const CMSDrugTableComponent = ({
  setCmsDrugSelectedRow,
  setGridApi,
  setColumnApi,
  setFullScreen,
}) => {
  const commentsList = useSelector((state) => {
    return state.sharedState.CommentsReducer?.CommentListData;
  });
  const currentNDCDetailsSelected = useSelector(
    (state) => state.sharedState.ndc.currentNDCDetailsSelected
  );
  const generalSystemParameterDetails = useSelector(
    (state) => state?.sharedState?.ndc?.generalSystemParameter?.paramGeneralVO
  );
  const [hideCmsUraInd, setHideCmsUraInd] = useState(null);

React.useEffect(() => {
  if (generalSystemParameterDetails?.[0]?.hideCmsUraInd !== undefined) {
    setHideCmsUraInd(generalSystemParameterDetails[0].hideCmsUraInd);
  }
}, [generalSystemParameterDetails]);

  const dispatch = useDispatch();
  const [showComments1, setShowComments1] = React.useState(false);
  const [openURADialog, setOpenURADialog] = useState({
    open: false,
    data: null,
  });
  const [corrLinkId, setCorrLinkId] = React.useState(null);
  const [corrId, setCorrId] = useState(null);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [gridParams, setGridParams] = React.useState(null);
  const [displayData, setDisplayData] = useState(false);
  const [rowData, setRowData] = React.useState(null);

  const handleCloseURADialog = () => {
    setOpenURADialog({ open: false, data: null });
  };

  const onGridReady = (params) => {
    setGridParams(params);
    setColumnApi(params.columnApi);
    params.api.forEachNode((node) => {
      if (node.rowIndex === 0) {
        node.setSelected(true);
        setCmsDrugSelectedRow(node.data);
      }
    });
  };
  React.useEffect(() => {
    const newRowData = currentNDCDetailsSelected?.cmsDrugVOs || [];
    setRowData(newRowData);

    if (gridParams?.api) {
      gridParams.api.deselectAll();
      if (newRowData.length > 0) {
        gridParams.api.forEachNode((node) => {
          if (node.rowIndex === 0) {
            node.setSelected(true);
            setCmsDrugSelectedRow(node.data);
          }
        });
      } else {
        setCmsDrugSelectedRow(null);
      }
    } else if (newRowData.length > 0) {
      setCmsDrugSelectedRow(newRowData[0]);
    } else {
      setCmsDrugSelectedRow(null);
    }
  }, [currentNDCDetailsSelected, gridParams]);

  // check if any comment add on particular ccCommentsExist value
  React.useEffect(() => {
    if (showComments1) {
      const tempObj =
        currentNDCDetailsSelected?.cmsDrugVOs?.length > 0 &&
        currentNDCDetailsSelected?.cmsDrugVOs?.map((item) => {
          if (
            item.corrLinkId === corrLinkId &&
            commentsList &&
            commentsList.length > 0
          ) {
            item.ccCommentsExist = 1;
          } else if (item.corrLinkId === corrLinkId) {
            item.ccCommentsExist = 0;
          }
          return item;
        });
      const temp = { ...currentNDCDetailsSelected };
      temp.cmsDrugVOs = [...tempObj];
      setRowData(tempObj);
      dispatch(setCurrentNDCDetailsSelected(temp, 'cmsDrugVOs'));
      // eslint-disable-next-line no-unused-expressions
      if (gridParams?.api) gridParams?.api?.refreshCells();
    }
  }, [commentsList]);

  const handleFullScreenViewClick = () => {
    setFullScreenView(!fullScreenView);
    setFullScreen(!fullScreenView);
  };

  return (
    <div className='table-container eightRecords col-12'>
      {/* {displayData ? ( */}
      <Grid
        gridHeight={fullScreenView ? '100vh' : 350}
        fullScreenView={fullScreenView}
        rowData={rowData || []}
        defaultCol={{ editable: false }}
        columnDefs={CMS_DRUG_TABLEHEAD}
        data-testid='onEditingStopped'
        noGlobalSort
        enterMovesDown
        suppressCellFocus
        onCellFocused={onCellFocused}
        singleClickEdit={false}
        navigateToNextCell={navigateToNextCell}
        // tabToNextCell={tabToNextCell}
        handleFullScreenViewClick={handleFullScreenViewClick}
        exportFile
        fileName='CMS Drug'
        onGridReady={onGridReady}
        onSelect={(e) => {
          setCmsDrugSelectedRow(e.data);
        }}
        frameworkComponents={{
          ActionCellRender: (cellInfo) => {
            if (cellInfo?.data?.isBottomRow) {
              return null;
            }
            return (
              <div className='tdCell icon-btn-group text-black d-flex mh-100 h-100 align-items-center'>
                <OverlayTrigger
                  placement='bottom'
                  overlay={<Tooltip id='com-tooltip'>Comment</Tooltip>}
                >
                  {showComments1 ? (
                    <Button
                      onClick={() => {
                        setCorrLinkId(cellInfo.data?.corrLinkId);
                        setCorrId(cellInfo?.data?.labelerCode); // check setCorrId
                        setShowComments1(true);
                      }}
                      tabIndex={'0'}
                      onKeyDown={(e) => {
                        // Handle Enter and Space key events
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault(); // Prevents the default space scrolling behavior
                          setCorrLinkId(cellInfo.data?.corrLinkId);
                          setCorrId(cellInfo?.data?.labelerCode); // check setCorrId
                          setShowComments1(true);
                        }
                      }}
                      aria-label='Comment'
                      className={`th-ic comment-ic ${
                        parseInt(cellInfo.data.ccCommentsExist, [0, 1]) === 1
                          ? 'frr-enabled-comment-btn'
                          : 'frr-disabled-comment-btn'
                      }`}
                      variant='text'
                    >
                      {parseInt(cellInfo.data.ccCommentsExist, [0, 1]) === 1 ? (
                        <img alt='' src={CommentVisibleIcon} />
                      ) : (
                        <img alt='' src={CommentIcon} />
                      )}
                    </Button>
                  ) : (
                    <Button
                      disabled={cellInfo.data?.corrLinkId === 'new'}
                      onClick={() => {
                        setCorrLinkId(cellInfo.data?.corrLinkId);
                        setCorrId(cellInfo?.data?.labelerCode); // check setCorrId
                        setShowComments1(true);
                      }}
                      tabIndex={'0'}
                      onKeyDown={(e) => {
                        // Handle Enter and Space key events
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault(); // Prevents the default space scrolling behavior
                          setCorrLinkId(cellInfo.data?.corrLinkId);
                          setCorrId(cellInfo?.data?.labelerCode); // check setCorrId
                          setShowComments1(true);
                        }
                      }}
                      aria-label='Comment'
                      className={`th-ic comment-ic ${
                        parseInt(cellInfo.data?.ccCommentsExist, [0, 1]) === 1
                          ? 'frr-enabled-comment-btn'
                          : 'frr-disabled-comment-btn'
                      }`}
                      variant='text'
                    >
                      {parseInt(cellInfo.data.ccCommentsExist, [0, 1]) === 1 ? (
                        <img alt='' src={CommentVisibleIcon} />
                      ) : (
                        <img alt='' src={CommentIcon} />
                      )}
                    </Button>
                  )}
                </OverlayTrigger>

                {hideCmsUraInd !== 1 && (
                  <div
                    className='tdCell icon-btn-group'
                    data-testid='action-column'
                  >
                    <Dropdown className='icon-dropdown-container'>
                      <Dropdown.Toggle
                        className='icon-dropdown export_wrap'
                        aria-label='export'
                      >
                        <OverlayTrigger
                          placement='bottom'
                          overlay={
                            <Tooltip id='action-tooltip'>Actions</Tooltip>
                          }
                        >
                          <SVGComponent iconName='Icon-export1' />
                        </OverlayTrigger>
                      </Dropdown.Toggle>
                      <Dropdown.Menu className='export_dropdown'>
                        <Dropdown.Item
                          role='button'
                          onClick={() => {
                            setOpenURADialog({
                              open: true,
                              data: {
                                index: cellInfo.rowIndex,
                                data: [
                                  {
                                    ...cellInfo.data,
                                    newUnitRebateAmt: null,
                                    newTerminationDt: null,
                                  },
                                ],
                              },
                            });
                          }}
                        >
                          Correction
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                )}
              </div>
            );
          },
          dateComponent: CustomDateComponent,
        }}
      />
      {/* ) : null} */}
      <CMSDrugURAUpdationDialog
        open={openURADialog?.open}
        data={openURADialog.data}
        handleClose={handleCloseURADialog}
      />
      {showComments1 ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments1}
          linkTableName='CMS_DRUG'
          corrLinkId={corrLinkId}
          rowGridPrimaryKey={corrId}
        />
      ) : null}
    </div>
  );
};

export default CMSDrugTableComponent;
